import { Component, OnInit } from '@angular/core';
import { TcPage, IPageState } from '@tc/core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-time-imputations-page',
  templateUrl: './time-imputations-page.component.html',
  styleUrls: ['./time-imputations-page.component.scss']
})
export class TimeImputationsPageComponent extends TcPage implements OnInit {

  constructor(
    store: Store<any>) {
    super(store);
  }

  ngOnInit() {
    const pageInfo: IPageState = {
      title: 'time-imputations-page.title'
    };

    this.pageInfo = pageInfo;

    super.ngOnInit();
  }

}
